import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colours } from '../Styles';

function Btn(props) {
    const { transpDark, light } = colours;
const Btn = styled.button`
    font-family: 'Play', sans-serif;
    font-size: 16px;
    background: transparent;
    border: 2px solid ${light};
    width: 150px;     
    height: 50px;
    border-radius: 5px;
    color: ${light};
    cursor: pointer;
    transition: 400ms ease-in-out;
    margin: 0 10px 0 10px;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    :hover {
        width: 170px;
        background: ${transpDark};
        border: 2px solid ${transpDark};
        margin: 0;
        span {
            color: ${light};
            margin-left: 5px;
        }
    }
    span {
        color: transparent;
        transition: 500ms;
        margin-left: -20px;
    }
    `;
    return (
        <Link to={props.address}>
            <Btn>{props.text}<span>>>></span></Btn>
        </Link>
    )
}

export default Btn;